import { IApplicationState } from '../../types/redux';

export function getIsSalesStartOnboardingEnabled(state: IApplicationState): boolean {
  return state.salesStartOnboarding.onboardingEnabled;
}
